import React, { useState } from 'react';
import { FaWhatsapp, FaPhone, FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaChevronUp } from 'react-icons/fa';
import './FloatingWidget.css';

const FloatingWidget = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    {
      icon: <FaWhatsapp />,
      label: 'WhatsApp',
      url: 'https://wa.me/919560424647',
      color: '#25D366',
      className: 'whatsapp-btn'
    },
    {
      icon: <FaPhone />,
      label: 'Call Now',
      url: 'tel:+919560424647',
      color: '#34B7F1',
      className: 'call-btn'
    },
    {
      icon: <FaFacebook />,
      label: 'Facebook',
      url: '#',
      color: '#1877F2',
      className: 'facebook-btn'
    },
    {
      icon: <FaInstagram />,
      label: 'Instagram',
      url: '#',
      color: '#E4405F',
      className: 'instagram-btn'
    },
    // {
    //   icon: <FaTwitter />,
    //   label: 'Twitter',
    //   url: '#',
    //   color: '#1DA1F2',
    //   className: 'twitter-btn'
    // },
    // {
    //   icon: <FaLinkedin />,
    //   label: 'LinkedIn',
    //   url: '#',
    //   color: '#0077B5',
    //   className: 'linkedin-btn'
    // }
  ];

  return (
    <div className="floating-widget">
      {/* Main Toggle Button */}
      {/* <button
        className={`floating-main-btn ${isExpanded ? 'expanded' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="Toggle social media menu"
      >
        <span className="floating-icon">+</span>
      </button> */}

      {/* Social Media Buttons */}
      <div className={`floating-buttons ${isExpanded ? 'show' : ''}`}>
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target={link.url.startsWith('http') ? '_blank' : '_self'}
            rel={link.url.startsWith('http') ? 'noopener noreferrer' : ''}
            className={`floating-btn ${link.className}`}
            style={{ '--delay': `${index * 0.1}s` }}
            aria-label={link.label}
            title={link.label}
          >
            {link.icon}
            <span className="floating-tooltip">{link.label}</span>
          </a>
        ))}
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <FaChevronUp />
        </button>
      )}
    </div>
  );
};

export default FloatingWidget;



